import { config } from '@fortawesome/fontawesome-svg-core'
import { graphql, StaticQuery } from 'gatsby'
import React from 'react'
import Helmet from 'react-helmet'

import { Footer } from './Footer'
import Navbar from './Navbar'

// These must be in this order
import './styles/gridlex.scss'

// Global must go afterwards to override gridlex styles
import './styles/global.css'

config.autoAddCss = false

type Props = {
  title?: string
  description?: string
  children: JSX.Element
  isLight?: boolean
}

const TemplateWrapper = ({ children, isLight, title, description }: Props) => (
  <StaticQuery
    query={graphql`
      query HeadingQuery {
        metaData: markdownRemark(frontmatter: { dataKey: { eq: "metadata-content" } }) {
          frontmatter {
            title
            description
          }
        }
      }
    `}
    render={data => (
      <div>
        <Helmet>
          <html lang="en" />
          <title>{title || data.metaData.frontmatter.title}</title>
          <meta name="description" content={description || data.metaData.frontmatter.description} />

          <link rel="apple-touch-icon" sizes="180x180" href="/img/apple-touch-icon.png" />
          <link rel="icon" type="image/png" href="/img/favicon-32x32.png" sizes="32x32" />
          <link rel="icon" type="image/png" href="/img/favicon-16x16.png" sizes="16x16" />
          <link rel="stylesheet" href="https://use.typekit.net/zpv5mmz.css" />
          <meta name="theme-color" content="#fff" />

          <meta property="og:type" content="business.business" />
          <meta property="og:title" content={title || data.metaData.frontmatter.title} />
          <meta
            property="og:description"
            content={description || data.metaData.frontmatter.description}
          />
          <meta property="og:url" content="/" />
          {/* Uncomment when we want a social mediabanner image
           <meta property="og:image" content="/img/og-image.jpg" /> */}
        </Helmet>
        <Navbar isLight={isLight} />
        <div>{children}</div>
        <Footer />
      </div>
    )}
  />
)

export default TemplateWrapper
